export default __webpack_public_path__ + "static/media/graf-cta.3901c249.svg";